import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import { MagritteBannerTitle } from 'components/common/MagritteBannerTitle/MagritteBannerTitle';

import { setCampaignTitle } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    label: 'AdCreate.AdForm.AdCampaignTitle.label',
    placeholder: 'AdCreate.AdForm.AdCampaignTitle.placeholder',
};

export const AdCampaignTitle: FC = () => {
    const { adCampaignTitle, campaignErrors } = useSelector((state) => state.createCampaign);

    const dispatch = useDispatch();
    const trls = useTrls();

    const onChange = (value: string) => {
        dispatch(setCampaignTitle(value));
    };

    return (
        <MagritteBannerTitle
            value={adCampaignTitle}
            onChange={onChange}
            error={campaignErrors.adCampaignTitle}
            label={trls(TrlKeys.label)}
            placeholder={trls(TrlKeys.placeholder)}
            vSpacingBottom={32}
            dataQa="campaign-title-input"
        />
    );
};
